import {
  Exceptions,
  INSTANTIATE_WAPP,
  InstantiateWappAPI,
  OPEN_STATIC_WAPP_BY_NAME,
  OPEN_WAPP,
  OpenStaticWappByNameAPI,
  OpenWappAPI,
  REFRESH_CONTENT_SESSIONS,
  RefreshContentSessionsAPI,
  StaticWappName,
  WappMode,
} from '@weblite-wapps/protocol'
import {
  getWappSessionsByWappId,
  restartWappSession,
} from 'weblite-web-wapprunner'
import {
  getStaticPanelByName,
  getStaticPanelByWappId,
  getStaticPanelByWappSessionId,
  isValidStaticWapp,
  OverlayWappPanel,
  WappPanel,
} from '$logic/wapp-panels'
import { getWis } from '$logic/wises'
import { hasPrivilegeToOpen } from '../helper/wapps.helper'
import { wappSubscription } from '../helper/subscription-handler'
import { registerAwaitingParent } from '../helper/awaitingParentsForOutput'

wappSubscription.subscribe<InstantiateWappAPI>(
  INSTANTIATE_WAPP,
  async payload => {
    const { wappId, input } = payload

    // TODO: Implement me!
    return { wappId, wisId: '', input }
  },
)

wappSubscription.subscribe<OpenWappAPI>(OPEN_WAPP, async (payload, meta) => {
  const { wappId, wisId, input, mode, awaitOutput } = payload

  if (mode === WappMode.INLINE) return { errorCode: Exceptions.INVALID }
  if (!hasPrivilegeToOpen(meta.mode, mode))
    return { errorCode: Exceptions.TEMPORARILY_NOT_AVAILABLE }

  if (mode === WappMode.MAIN) {
    // parent: INLINE | STATIC | MAIN
    await WappPanel.openWapp({ wappId, wisId, input, parentWapp: meta })
    return meta.mode === WappMode.MAIN || !awaitOutput
      ? { status: 'ok' }
      : { output: await registerAwaitingParent(meta) }
  }

  if (mode === WappMode.OVERLAY) {
    // parent: INLINE | STATIC | MAIN | OVERLAY
    await OverlayWappPanel.openWapp({ wappId, wisId, input, parentWapp: meta })
    return meta.mode === WappMode.OVERLAY || !awaitOutput
      ? { status: 'ok' }
      : { output: await registerAwaitingParent(meta) }
  }

  if (isValidStaticWapp(payload)) {
    // parent: INLINE | STATIC | MAIN
    // @ts-ignore
    getStaticPanelByWappId(wappId).open?.(input)
    return { status: 'ok' }
  }

  return { errorCode: Exceptions.INVALID }
})

const oldNamesToNewNamesMap = {
  KOOLEH: 'kooleh',
  RAHKAR: 'rahkar',
  MAVAKEB: 'mavakeb',
  JARYAN: 'jaryan',
}

wappSubscription.subscribe<OpenStaticWappByNameAPI>(
  OPEN_STATIC_WAPP_BY_NAME,
  async (staticWappName, meta) => {
    if (
      isValidStaticWapp(meta) &&
      Object.keys(oldNamesToNewNamesMap).includes(staticWappName)
    ) {
      // @ts-ignore
      getStaticPanelByName(oldNamesToNewNamesMap[staticWappName])?.open()
      return { status: 'ok' }
    }

    return { errorCode: Exceptions.INVALID }
  },
)

wappSubscription.subscribe<RefreshContentSessionsAPI>(
  REFRESH_CONTENT_SESSIONS,
  async ({ wappId, contentUri }) => {
    const sessions = getWappSessionsByWappId(wappId)

    await Promise.all(
      sessions.map(async ({ wisId, mode, wappSessionId }) => {
        if (!wisId || mode !== WappMode.INLINE) return

        const wis = await getWis(wisId)
        if (wis?.customize?.contentUri !== contentUri) return

        await restartWappSession(wappSessionId)
      }),
    )

    return { status: 'ok' }
  },
)
